import {RenderModal} from "../../Functions/RenderModal";
import {ShoppingList} from "../ShoppingList";

/**
 *  Shopping List delete all artikels
 */
function pruneListListener(button: HTMLElement, confirmationModal: HTMLElement) {
    const confirmDelete = confirmationModal.querySelector('.confirm-delete').textContent;
    const confirmCancel = confirmationModal.querySelector('.confirm-cancel').textContent;
    const content = confirmationModal.innerHTML;
    const list = ShoppingList.getShoppingList(button);

    RenderModal.init(
        '',
        content,
        {
            confirm: {
                label: confirmDelete,
                className: 'btn-primary',
                callback: function () {
                    document.querySelector('.dropdown.open')?.classList.remove('open');
                    document.querySelector('.select-abort')?.dispatchEvent(new Event('click'));

                    ShoppingList.removeItemsFromShoppingList('all', list);
                }
            },
            cancel: {
                label: confirmCancel,
                className: 'btn-default',
                callback: function () {}
            }
        },
        false,
        'small'
    );
}

export function initPruneList() {
    const deleteAllItems = document.querySelectorAll('.delete-all-items') as NodeListOf<HTMLElement>;
    const confirmationModal = document.querySelector('.confirmationmodal') as HTMLElement;

    if (!confirmationModal || !deleteAllItems.length) {
        return;
    }

    deleteAllItems.forEach((button) => {
        button.addEventListener('click', (e: Event) => {
            e.preventDefault();
            pruneListListener(button, confirmationModal);
        });
    });
}
